import React from 'react';
import { Users } from 'lucide-react';

/** Old pick slips carry only a customer name — when it matches several Customer Master records, pick the right one. */
export const CustomerPick = ({ choices, value, onChange }) => (
  <div className="rounded-lg border border-amber-300 bg-amber-50 p-3 space-y-2" data-testid="ewb-customer-pick">
    <div className="flex items-center gap-1.5 text-sm font-semibold text-amber-900">
      <Users className="w-4 h-4" />This customer name matches {choices.length} customers in Customer Master — pick the right one
    </div>
    <div className="grid gap-1.5">
      {choices.map((c) => (
        <label key={c.id} className={`flex flex-wrap items-center gap-x-3 gap-y-0.5 rounded-md border bg-white px-3 py-2 text-sm cursor-pointer transition-colors ${value === c.id ? 'border-[#2D5F4F] ring-1 ring-[#2D5F4F]' : 'border-gray-200 hover:border-gray-400'}`}
          data-testid={`ewb-customer-choice-${c.id}`}>
          <input type="radio" name="ewb-customer" checked={value === c.id} onChange={() => onChange(c.id)} className="accent-[#2D5F4F]" />
          <span className="font-mono text-xs text-gray-500">ID {c.id}</span>
          <span className="font-medium">{c.name}</span>
          <span className="text-gray-600">{[c.place, c.state].filter(Boolean).join(', ')}</span>
          <span className="font-mono text-xs">{c.gstin || 'URP'}</span>
          <span className="rounded-full bg-slate-100 px-2 text-[11px] font-semibold text-slate-700">{c.channel || 'no channel'}</span>
        </label>
      ))}
    </div>
  </div>
);

export default CustomerPick;
